import axios from "axios";

const createProduct = async (token, tourId, values) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/products`;
  try {
    const response = await axios.post(path, values, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
}

export default createProduct;